/**
 * AmaraPure blue-light glasses landing page.
 * Ported 1:1 from the source artifact's data/behavior (models, swatches, bundle math,
 * gallery logic) into vanilla JS. Only the copy comes from Liquid settings; everything
 * else here (catalog data, formulas, state machine) is intentionally hardcoded to match
 * the original.
 */
(function () {
  if (window.__apLpInit) return;
  window.__apLpInit = true;

  var CDN = 'https://amarapure.nl/cdn/shop/files/';
  var W = '&width=1200';
  function u(f) { return CDN + f + W; }
  // { src, variantId, available } per color. Variant IDs + availability are hardcoded
  // (fetched once via Admin API) instead of looked up live, because the live product
  // JSON endpoint is keyed by handle+domain and these handles don't resolve on every
  // market's storefront domain — Admin API data is market/domain-independent and the
  // variant ID itself never changes, so /cart/add.js works the same everywhere.
  function c(src, variantId, available, bundleVariantId, price) { return { src: src, variantId: variantId, available: available, bundleVariantId: bundleVariantId, price: price }; }

  var MODELS = [
    { name: 'Nona', handleDay: 'amarapure-blauwlichtbril-daygold-black', handleNight: 'amarapure-blauwlichtbril-midnight-black',
      day: { 'Zwart': c(u('SR2119_BLACK_YELLOW_FRONT.webp?v=1773336746'), 51976913617235, false, 54604630655315, 69), 'Crystal': c(u('SR2119_TRANSPARENT_YELLOW_FRONT_c812dc81-15e8-4ac9-ba85-cf3d52116fc7.webp?v=1771332467'), 51976913650003, true, 54604630622547, 69), 'Crystal Grey': c(u('SR2119_GREY_YELLOW_FRONT.jpg?v=1773336746'), 51976913682771, true, 54604630688083, 69) },
      dayExtra: [{ c: 'Zwart', src: u('SR2119_BLACK_YELLOW_ANGLE.webp?v=1771332467') }, { c: 'Zwart', src: u('SR2119_BLACK_YELLOW_CLOSE-UP.webp?v=1771332467') }, { c: 'Zwart', src: u('SR2119_BLACK_YELLOW_SIDE.webp?v=1771332467') }, { c: 'Crystal', src: u('SR2119_TRANSPARENT_YELLOW_ANGLE.webp?v=1759153970') }, { c: 'Crystal', src: u('SR2119_TRANSPARENT_YELLOW_CLOSE-UP.webp?v=1759153970') }, { c: 'Crystal', src: u('SR2119_TRANSPARENT_YELLOW_SIDE.webp?v=1759153969') }, { c: 'Crystal Grey', src: u('SR2119_GREY_YELLOW_ANGLE.jpg?v=1763212715') }, { c: 'Crystal Grey', src: u('SR2119_GREY_YELLOW_CLOSE-UP.jpg?v=1763212716') }, { c: 'Crystal Grey', src: u('SR2119_GREY_YELLOW_SIDE.jpg?v=1763212715') }],
      night: { 'Zwart': c(u('AmaraPure-Blauwlichtbril-Midnight-Black-scaled-1.webp?v=1773264072'), 51976653144403, true, 54604631081299, 69), 'Crystal': c(u('SET_2_TRANSPARANT_ORANJE_FRONT_12301d65-f321-4400-aa8b-c7fbe02c5a6c.jpg?v=1771332380'), 51976653177171, true, 54604631048531, 69), 'Crystal Grey': c(u('SR2119_GREY_ORANGE_FRONT5.jpg?v=1773264072'), 51976653209939, true, 54604631114067, 69) },
      nightExtra: [{ c: 'Zwart', src: u('SR2119_BLACK_ORANGE_CLOSE.jpg?v=1771535772') }, { c: 'Zwart', src: u('SR2119_BLACK_ORANGE_ANGLE.jpg?v=1771535771') }, { c: 'Zwart', src: u('SR2119_BLACK_ORANGE_SIDE.jpg?v=1771535771') }, { c: 'Crystal', src: u('SR2119_TRANSPARENT_ORANGE_SIDE.jpg?v=1771535635') }, { c: 'Crystal', src: u('SR2119_TRANSPARENT_ORANGE_ANGLE.jpg?v=1771535638') }, { c: 'Crystal', src: u('SR2119_TRANSPARENT_ORANGE_CLOSE.jpg?v=1771535638') }, { c: 'Crystal Grey', src: u('SR2119_GREY_ORANGE_CLOSE-UP.jpg?v=1763212911') }, { c: 'Crystal Grey', src: u('SR2119_GREY_ORANGE_ANGLE.jpg?v=1763212911') }, { c: 'Crystal Grey', src: u('SR2119_GREY_ORANGE_SIDE.jpg?v=1763212911') }] },
    { name: 'Medula', handleDay: 'amarapure-blauwlichtbril-daygold-medula-black', handleNight: 'amarapure-blauwlichtbril-midnight-medula-black',
      day: { 'Zwart': c(u('AmaraPure-Blauwlichtbril-Daygold-Medula-Black-scaled-1.webp?v=1773337330'), 51977876930899, true, 54604631540051, 69), 'Crystal': c(u('SET_1_TRANSPARANT_GEEL_FRONT_1_20c62281-037c-4f87-9815-725949616d9d.jpg?v=1771332852'), 51977876963667, true, 54604631507283, 69) },
      dayExtra: [{ c: 'Zwart', src: u('SR2301_BLACK_YELLOW_CLOSE-UP.jpg?v=1768236009') }, { c: 'Zwart', src: u('SR2301_BLACK_YELLOW_SIDE.jpg?v=1771332852') }, { c: 'Crystal', src: u('SR2301_TRANSPARENT_YELLOW_SIDE_1.jpg?v=1771536782') }, { c: 'Crystal', src: u('SR2301_TRANSPARENT_YELLOW_ANGLE_1.jpg?v=1771536783') }, { c: 'Crystal', src: u('SR2301_TRANSPARENT_YELLOW_CLOSE_1.jpg?v=1771536784') }],
      night: { 'Zwart': c(u('AmaraPure-Blauwlichtbril-Midnight-Medula-Black-1-scaled-1.webp?v=1773264414'), 51976919810387, false, 54604631933267, 69), 'Crystal': c(u('SET_1_TRANSPARANT_ORANJE_FRONT_4013eb1c-2cb5-4ab1-9d5c-6aea1103628a.jpg?v=1771332774'), 51976919843155, false, 54604631900499, 69) },
      nightExtra: [{ c: 'Zwart', src: u('SR2301_BLACK_ORANGE_CLOSE-UP.jpg?v=1768236009') }, { c: 'Zwart', src: u('SR2301_BLACK_ORANGE_ANGLE.jpg?v=1771332774') }, { c: 'Zwart', src: u('SR2301_BLACK_ORANGE_SIDE.jpg?v=1771332774') }, { c: 'Crystal', src: u('TRANSPARENT_ORANGE_ANGLE.jpg?v=1771536203') }, { c: 'Crystal', src: u('TRANSPARENT_ORANGE_CLOSE.jpg?v=1771536204') }, { c: 'Crystal', src: u('TRANSPARENT_ORANGE_SIDE.jpg?v=1771536203') }] },
    { name: 'Seraphim', handleDay: 'amarapure%E2%84%A2-blauwlichtbril-seraphim-daygold-black', handleNight: 'amarapure%E2%84%A2-blauwlichtbril-seraphim-midnight-black',
      day: { 'Zwart': c(u('SR8101_BLACK_YELLOW_FRONT.webp?v=1773335268'), 51977817096531, false, 54604632326483, 79), 'Crystal': c(u('SR8101_TRANSPARENT_YELLOW_FRONT_fa9561e2-9be0-48c5-bc00-07d0909c633c.jpg?v=1771331205'), 52388666966355, true, 54604632293715, 79), 'Groen': c(u('SR8101_GREY_YELLOW_FRONT_5952eaab-eedc-4fa6-870d-85ba6fa2fde4.webp?v=1773335268'), 51977817129299, true, 54604632359251, 79) },
      dayExtra: [{ c: 'Zwart', src: u('SR8101_BLACK_YELLOW_ANGLE.webp?v=1771331205') }, { c: 'Zwart', src: u('SR8101_BLACK_YELLOW_CLOSE-UP.webp?v=1771331205') }, { c: 'Zwart', src: u('SR8101_BLACK_YELLOW_SIDE.webp?v=1771331205') }, { c: 'Crystal', src: u('SR8101_TRANSPARENT_YELLOW_ANGLE.jpg?v=1763215506') }, { c: 'Crystal', src: u('SR8101_TRANSPARENT_YELLOW_CLOSE-UP.jpg?v=1763215506') }, { c: 'Crystal', src: u('SR8101_TRANSPARENT_YELLOW_SIDE.jpg?v=1763215506') }, { c: 'Groen', src: u('SR8101_GREY_YELLOW_ANGLE.webp?v=1758907807') }, { c: 'Groen', src: u('SR8101_GREY_YELLOW_CLOSE-UP.webp?v=1758907807') }, { c: 'Groen', src: u('SR8101_GREY_YELLOW_SIDE.webp?v=1758907807') }],
      night: { 'Zwart': c(u('SR8101_BLACK_ORANGE_FONT.webp?v=1773252582'), 51977799696723, true, 54604632818003, 79), 'Crystal': c(u('SR8108_TRANSPARENT_ORANGE_FRONT_228f48a5-887a-4c28-8cdf-e8c5e2d57b4b.jpg?v=1771331034'), 52388643963219, true, 54604632785235, 79), 'Groen': c(u('SR8101_GREY_ORANGE_FRONT_b9842294-cad5-43af-9944-92ba332a258a_1.webp?v=1773252582'), 51977799729491, true, 54604632850771, 79) },
      nightExtra: [{ c: 'Zwart', src: u('SR8101_BLACK_ORANGE_ANGLE.webp?v=1771331034') }, { c: 'Zwart', src: u('SR8101_BLACK_ORANGE_CLOSE-UP.webp?v=1771331034') }, { c: 'Zwart', src: u('SR8101_BLACK_ORANGE_SIDE.webp?v=1771331034') }, { c: 'Crystal', src: u('SR8108_TRANSPARENT_ORANGE_ANGLE.jpg?v=1763215253') }, { c: 'Crystal', src: u('SR8108_TRANSPARENT_ORANGE_CLOSE-UP.jpg?v=1763215255') }, { c: 'Crystal', src: u('SR8108_TRANSPARENT_ORANGE_SIDE.jpg?v=1763215253') }, { c: 'Groen', src: u('SR8101_GREY_ORANGE_ANGLE.webp?v=1758906998') }, { c: 'Groen', src: u('SR8101_GREY_ORANGE_CLOSE-UP.webp?v=1758906998') }, { c: 'Groen', src: u('SR8101_GREY_ORANGE_SIDE.webp?v=1758906998') }] },
    { name: 'Angelic', handleDay: 'amarapure%E2%84%A2-blauwlichtbril-angelic-daygold-black', handleNight: 'amarapure%E2%84%A2-blauwlichtbril-angelic-midnight-black',
      day: { 'Zwart': c(u('SR553_YELLOW_FRONT.webp?v=1768234873'), 51626358604115, true, 54604633047379, 69) },
      dayExtra: [{ c: 'Zwart', src: u('SR553_YELLOW_ANGLE.webp?v=1768234873') }, { c: 'Zwart', src: u('SR553_YELLOW_CLOSE-UP.webp?v=1768234873') }],
      night: { 'Zwart': c(u('SR553_ORANGE_FRONT.webp?v=1768234873'), 51626358505811, true, 54604633243987, 69) },
      nightExtra: [{ c: 'Zwart', src: u('SR553_ORANGE_ANGLE.webp?v=1768234873') }, { c: 'Zwart', src: u('SR553_ORANGE_CLOSE-UP.webp?v=1768234873') }] },
    { name: 'Horizon', handleDay: 'amarapure-blauwlichtbril-daygold-horizon-black', handleNight: 'blauwlichtbril-midnight-horizon-crystal',
      day: { 'Zwart': c(u('AmaraPure-Blauwlichtbril-Daygold-Horizon-Black-1-scaled-1.webp?v=1773337111'), 51977941483859, true, 54604633440595, 69), 'Crystal': c(u('SET_4_TRANSPARANT_GEEL_FRONT_0744e4aa-24a3-40a1-b202-3230af654a00.jpg?v=1771332679'), 51977941516627, true, 54604633407827, 69) },
      dayExtra: [{ c: 'Zwart', src: u('SR5374_BLACK_YELLOW_ANGLE.jpg?v=1771535014') }, { c: 'Zwart', src: u('SR5374_BLACK_YELLOW_CLOSE.jpg?v=1771535015') }, { c: 'Zwart', src: u('SR5374_BLACK_YELLOW_SIDE.jpg?v=1771535013') }, { c: 'Crystal', src: u('SR5374_TRANSPARENT_YELLOW_ANGLE.jpg?v=1771534893') }, { c: 'Crystal', src: u('SR5374_TRANSPARENT_YELLOW_CLOSE.jpg?v=1771534895') }, { c: 'Crystal', src: u('SR5374_TRANSPARENT_YELLOW_SIDE.jpg?v=1771534894') }],
      night: { 'Zwart': c(u('Blauwlichtbril-Midnight-Horizon-Black_1_49f9a189-498b-41a8-a977-d31ec51d1cbf.webp?v=1769626020'), 51975949091155, true, 54604633669971, 69), 'Crystal': c(u('1_3.webp?v=1756829449'), 51975945552211, true, 54604633637203, 69) },
      nightExtra: [{ c: 'Zwart', src: u('SR5374_BLACK_ORANGE_ANGLE.jpg?v=1771535418') }, { c: 'Zwart', src: u('SR5374_BLACK_ORANGE_SIDE.jpg?v=1771535416') }, { c: 'Crystal', src: u('SR5374_TRANSPARENT_ORANGE_CLOSE.jpg?v=1771535324') }, { c: 'Crystal', src: u('SR5374_TRANSPARENT_ORANGE_ANGLE.jpg?v=1771535226') }, { c: 'Crystal', src: u('SR5374_TRANSPARENT_ORANGE_SIDE.jpg?v=1771535224') }] },
    { name: 'Luna', handleDay: 'amarapure-blauwlichtbril-daygold-luna-black', handleNight: 'amarapure-blauwlichtbril-midnight-luna-black',
      day: { 'Zwart': c(u('AmaraPure-Blauwlichtbril-Daygold-Luna-Black-scaled-1.webp?v=1773336972'), 51977932439891, true, 54604633997651, 69), 'Crystal': c(u('SET_3_TRANSPARANT_GEEL_FRONT_b7a0e1b0-7d5a-4fee-b159-ab194b5248ae.jpg?v=1771332626'), 51977932472659, true, 54604633964883, 69) },
      dayExtra: [{ c: 'Zwart', src: u('SR17179_BLACK_YELLOW_CLOSE.jpg?v=1771534289') }, { c: 'Zwart', src: u('SR17179_BLACK_YELLOW_ANGLE.jpg?v=1771534326') }, { c: 'Crystal', src: u('SET_3_TRANSPARANT_GEEL.jpg?v=1759224757') }, { c: 'Crystal', src: u('SET_3_TRANSPARANT_GEEL_SIDE.jpg?v=1759224757') }],
      night: { 'Zwart': c(u('AmaraPure-Blauwlichtbril-Midnight-Luna-Black-2-scaled-1.webp?v=1773264209'), 51977927983443, true, 54604634227027, 69), 'Crystal': c(u('SET_1_TRANSPARANT_ORANJE_FRONT_4013eb1c-2cb5-4ab1-9d5c-6aea1103628a.jpg?v=1771332774'), 51977928016211, true, 54604634194259, 69) },
      nightExtra: [{ c: 'Zwart', src: u('BLACK_ORANGE_CLOSE.jpg?v=1771533690') }, { c: 'Zwart', src: u('BLACK_ORANGE_SIDE.jpg?v=1771533687') }, { c: 'Zwart', src: u('BLACK_ORANGE_ANGLE.jpg?v=1771533689') }, { c: 'Crystal', src: u('SR17179_TRANSPARENT_ORANGE_CLOSE.jpg?v=1771533530') }, { c: 'Crystal', src: u('SR17179_TRANSPARENT_ORANGE_ANGLE.jpg?v=1771533528') }, { c: 'Crystal', src: u('SR17179_TRANSPARENT_ORANGE_SIDE.jpg?v=1771533527') }] },
    { name: 'Gaia', handleDay: 'amarapure%E2%84%A2-blauwlichtbril-gaia-daygold-black', handleNight: 'amarapure%E2%84%A2-blauwlichtbril-gaia-midnight-black',
      day: { 'Zwart': c(u('SRWZ01J_YELLOW_FRONT.webp?v=1768234649'), 51626360209747, true, 54604634423635, 79) },
      dayExtra: [{ c: 'Zwart', src: u('SRWZ01J_YELLOW_ANGLE.webp?v=1768234649') }, { c: 'Zwart', src: u('SRWZ01J_YELLOW_CLOSE-UP.webp?v=1768234649') }],
      night: { 'Zwart': c(u('SRWZ0J_ORANGE_FRONT.webp?v=1768234649'), 51626360176979, true, 54604634620243, 79) },
      nightExtra: [{ c: 'Zwart', src: u('SRWZ0J_ORANGE_ANGLE.webp?v=1768234649') }, { c: 'Zwart', src: u('SRWZ0J_ORANGE_CLOSE-UP.webp?v=1768234649') }] },
    { name: 'Athena', handleDay: 'amarapure%E2%84%A2-blauwlichtbril-athena-daygold-black', handleNight: 'amarapure%E2%84%A2-blauwlichtbril-athena-midnight-black',
      day: { 'Zwart': c(u('SRV8612_BLACK_YELLOW_FRONT.jpg?v=1773336399'), 53068830605651, true, 54604634816851, 69), 'Silver': c(u('SR8612_YELLOW_FRONT.webp?v=1768234828'), 53068830572883, true, 54604634784083, 69) },
      dayExtra: [{ c: 'Zwart', src: u('SRV8612_BLACK_YELLOW_CLOSE.jpg?v=1771531579') }, { c: 'Zwart', src: u('SRV8612_BLACK_YELLOW_ANGLE.jpg?v=1771531579') }, { c: 'Zwart', src: u('SRV8612_BLACK_YELLOW_SIDE.jpg?v=1771531578') }, { c: 'Silver', src: u('SR8612_YELLOW_ANGLE.webp?v=1768234828') }, { c: 'Silver', src: u('SR8612_YELLOW_CLOSE-UP.webp?v=1768234828') }, { c: 'Silver', src: u('SR8612_YELLOW_SIDE.webp?v=1768234828') }],
      night: { 'Zwart': c(u('SRV8612_BLACK_ORANGE_FRONT.jpg?v=1773262599'), 53066366779731, true, 54604635078995, 69), 'Rose Gold': c(u('SR8612_ORANGE_FRONT.webp?v=1768234828'), 53066366746963, true, 54604635046227, 69) },
      nightExtra: [{ c: 'Zwart', src: u('SRV8612_BLACK_ORANGE_CLOSE.jpg?v=1771500764') }, { c: 'Zwart', src: u('SRV8612_BLACK_ORANGE_ANGLE.jpg?v=1771500763') }, { c: 'Zwart', src: u('SRV8612_BLACK_ORANGE_SIDE.jpg?v=1771500763') }, { c: 'Rose Gold', src: u('SR8612_ORANGE_SIDE.webp?v=1768234828') }, { c: 'Rose Gold', src: u('SR8612_ORANGE_CLSOE-UP.webp?v=1768234828') }, { c: 'Rose Gold', src: u('SR8612_ORANGE_ANGLE.webp?v=1768234828') }] },
    { name: 'Skynet', handleDay: 'amarapure%E2%84%A2-blauwlichtbril-skynet-daygold-zwart', handleNight: 'amarapure%E2%84%A2-blauwlichtbril-skynet-midnight-zwart',
      day: { 'Zwart': c(u('SR8618_BLACK_YELLOW_FRONT.webp?v=1773336170'), 52388495262035, true, 54604635275603, 69), 'Crystal': c(u('SR8618_TRANSPARENT_YELLOW_FRONT_aacc649c-1958-414d-9174-8abdd6a98ca4.jpg?v=1771332934'), 52388495294803, true, 54604635242835, 69) },
      dayExtra: [{ c: 'Zwart', src: u('SR8618_BLACK_YELLOW_ANGLE.webp?v=1771332934') }, { c: 'Zwart', src: u('SR8618_BLACK_YELLOW_CLOSE-UP.webp?v=1771332934') }, { c: 'Zwart', src: u('SR8618_BLACK_YELLOW_SIDE.webp?v=1771332934') }, { c: 'Crystal', src: u('SR8618_TRANSPARENT_YELLOW_ANGLE.jpg?v=1763214025') }, { c: 'Crystal', src: u('SR8618_TRANSPARENT_YELLOW_CLOSE-UP.jpg?v=1763214026') }, { c: 'Crystal', src: u('SR8618_TRANSPARENT_YELLOW_SIDE.jpg?v=1763214025') }],
      night: { 'Zwart': c(u('SR8618_BLACK_ORANGE_FRONT.webp?v=1773262390'), 51977844031827, true, 54604635504979, 69), 'Crystal': c(u('SR8618_TRANSPARENT_ORANGE_FRONT.webp?v=1771331381'), 51977844064595, true, 54604635472211, 69) },
      nightExtra: [{ c: 'Zwart', src: u('SR8618_BLACK_ORANGE_ANGLE.webp?v=1771331381') }, { c: 'Zwart', src: u('SR8618_BLACK_ORANGE_CLOSE-UP.webp?v=1771331381') }, { c: 'Zwart', src: u('SR8618_BLACK_ORANGE_SIDE.webp?v=1771331381') }, { c: 'Crystal', src: u('SR8618_TRANSPARENT_ORANGE_ANGLE.webp?v=1758908748') }, { c: 'Crystal', src: u('SR8618_TRANSPARENT_ORANGE_CLOSE-UP.webp?v=1758908747') }, { c: 'Crystal', src: u('SR8618_TRANSPARENT_ORANGE_SIDE.webp?v=1758908748') }] },
    { name: 'Lyran', handleDay: 'amarapure%E2%84%A2-blauwlichtbril-lyran-daygold-black', handleNight: 'amarapure%E2%84%A2-blauwlichtbril-lyran-midnight-black',
      day: { 'Zwart': c(u('SR3007_BLACK_YELLOW_FRONT.webp?v=1768234446'), 53069591347539, true, 54604635701587, 79), 'Crystal': c(u('SR3007_TRANSPARENT_YELLOW_FRONT.jpg?v=1773335999'), 53069591314771, true, 54604635734355, 79), 'Crystal Grey': c(u('SR3007_GREY_YELLOW_FRONT.jpg?v=1773335999'), 53069591380307, false, 54604635767123, 79) },
      dayExtra: [{ c: 'Zwart', src: u('SR3007_BLACK_YELLOW_CLOSE-UP.webp?v=1768234446') }, { c: 'Zwart', src: u('SR3007_BLACK_YELLOW_ANGLE.webp?v=1768234446') }, { c: 'Zwart', src: u('SR3007_BLACK_YELLOW_SIDE.webp?v=1768234446') }, { c: 'Crystal', src: u('SR3007_TRANSPARENT_YELLOW_CLOSE.jpg?v=1771538435') }, { c: 'Crystal', src: u('SR3007_TRANSPARENT_YELLOW_ANGLE.jpg?v=1771538434') }, { c: 'Crystal', src: u('SR3007_TRANSPARENT_YELLOW_SIDE.jpg?v=1771538433') }, { c: 'Crystal Grey', src: u('SR3007_GREY_YELLOW_CLOSE.jpg?v=1771537340') }, { c: 'Crystal Grey', src: u('SR3007_GREY_YELLOW_ANGLE.jpg?v=1771537340') }, { c: 'Crystal Grey', src: u('SR3007_GREY_YELLOW_SIDE.jpg?v=1771537338') }],
      night: { 'Zwart': c(u('SR3007_BLACK_ORANGE_FRONT.webp?v=1768234446'), 53070063370579, true, 54604635963731, 79), 'Crystal': c(u('SR3007_TRANSPARENT_ORANGE_FRONT_dbd46e3f-acfd-4f9d-b31e-76ff5b1c89d5.jpg?v=1773261716'), 53070063403347, true, 54604635996499, 79), 'Crystal Grey': c(u('SR3007_GREY_ORANGE_FRONT_54491bfb-c912-4048-a2fd-2319dbe392c8.jpg?v=1773261716'), 53070063436115, true, 54604636029267, 79) },
      nightExtra: [{ c: 'Zwart', src: u('SR3007_BLACK_ORANGE_CLOSE-UP.webp?v=1768234446') }, { c: 'Zwart', src: u('SR3007_BLACK_ORANGE_ANGLE.webp?v=1768234446') }, { c: 'Zwart', src: u('SR3007_BLACK_ORANGE_SIDE.webp?v=1768234446') }, { c: 'Crystal', src: u('SR3007_TRANSPARENT_ORANGE_CLOSE.jpg?v=1771540066') }, { c: 'Crystal', src: u('SR3007_TRANSPARENT_ORANGE_ANGLE.jpg?v=1771540064') }, { c: 'Crystal', src: u('SR3007_TRANSPARENT_ORANGE_SIDE.jpg?v=1771540062') }, { c: 'Crystal Grey', src: u('SR3007_GREY_ORANGE_CLOSE.jpg?v=1771540066') }, { c: 'Crystal Grey', src: u('SR3007_GREY_ORANGE_ANGLE.jpg?v=1771540064') }, { c: 'Crystal Grey', src: u('SR3007_GREY_ORANGE_SIDE.jpg?v=1771540063') }] },
    { name: 'Titan', handleDay: 'amarapure%E2%84%A2-blauwlichtbril-titan-daygold-black', handleNight: null,
      day: { 'Zwart': c(u('SR2113_YELLOW_FRONT.webp?v=1768234235'), 51626360144211, true, 54604636225875, 69) },
      dayExtra: [{ c: 'Zwart', src: u('SR2113_YELLOW_ANGLE.webp?v=1768234235') }, { c: 'Zwart', src: u('SR2113_YELLOW_CLOSE-UP.webp?v=1768234235') }],
      night: null, nightExtra: [] }
  ];

  var SWATCH = { 'Zwart': '#141414', 'Crystal': '#DFDCD4', 'Crystal Grey': '#8C8A85', 'Silver': '#C7C9CB', 'Rose Gold': '#B76E79', 'Groen': '#8B9A7A' };

  // Every picker product (Solo/Duo/Trio) is priced uniformly at this amount
  // in Shopify, regardless of model, and a matching fixed-amount automatic
  // discount ("Bundelkorting Solo/Duo/Trio" in Admin) brings each tier down
  // to an exact, predictable total — €59 / €79 / €109 — no matter which
  // models are picked.
  var UNIFORM_BUNDLE_PRICE = 79;
  var TIER_DISCOUNT_AMOUNT = { 1: 20, 2: 79, 3: 128 };

  // Static lifestyle photos appended to the end of every gallery, picked by
  // storefront locale. NL and DE get their own localized set; every other
  // locale (including the default) falls back to the EN set.
  var MARKET_GALLERY = {
    nl: [
      'https://cdn.shopify.com/s/files/1/0964/5680/2643/files/NL-1_2f2f5a75-2ed3-4dce-9af7-e15835ee38d9.jpg?v=1784071662',
      'https://cdn.shopify.com/s/files/1/0964/5680/2643/files/NL-2_60fa4979-e219-4a93-bed5-a6bb34648d88.jpg?v=1784071666',
      'https://cdn.shopify.com/s/files/1/0964/5680/2643/files/NL-3_2199bb5a-928a-46e9-915a-258b3b82cda5.jpg?v=1784071669',
      'https://cdn.shopify.com/s/files/1/0964/5680/2643/files/NL-4_17f80ce9-0e28-4b14-8722-030431a4d50f.jpg?v=1784071671',
      'https://cdn.shopify.com/s/files/1/0964/5680/2643/files/NL-5_abf92344-b870-475a-9cff-8b3874a925a0.jpg?v=1784071670',
      'https://cdn.shopify.com/s/files/1/0964/5680/2643/files/NL-6_ffef962e-3d7a-442f-b692-3cc1dc18711a.jpg?v=1784071667'
    ],
    de: [
      'https://cdn.shopify.com/s/files/1/0964/5680/2643/files/DE_1.jpg?v=1784072655',
      'https://cdn.shopify.com/s/files/1/0964/5680/2643/files/DE_2.jpg?v=1784072660',
      'https://cdn.shopify.com/s/files/1/0964/5680/2643/files/DE_3.jpg?v=1784072662',
      'https://cdn.shopify.com/s/files/1/0964/5680/2643/files/DE_4.jpg?v=1784072662',
      'https://cdn.shopify.com/s/files/1/0964/5680/2643/files/DE_5.jpg?v=1784072662',
      'https://cdn.shopify.com/s/files/1/0964/5680/2643/files/DE_6.jpg?v=1784072661'
    ],
    en: [
      'https://cdn.shopify.com/s/files/1/0964/5680/2643/files/EN_1.jpg?v=1784072394',
      'https://cdn.shopify.com/s/files/1/0964/5680/2643/files/EN_2.jpg?v=1784072398',
      'https://cdn.shopify.com/s/files/1/0964/5680/2643/files/EN_3.jpg?v=1784072401',
      'https://cdn.shopify.com/s/files/1/0964/5680/2643/files/EN_4.jpg?v=1784072402',
      'https://cdn.shopify.com/s/files/1/0964/5680/2643/files/EN_5.jpg?v=1784072402',
      'https://cdn.shopify.com/s/files/1/0964/5680/2643/files/EN_6.jpg?v=1784072399'
    ]
  };

  function eur(n) {
    return '€' + (Number.isInteger(n) ? String(n) : n.toFixed(2).replace('.', ','));
  }

  function promoEnd() {
    var d = new Date();
    var days = (7 - d.getDay()) % 7;
    var end = new Date(d.getFullYear(), d.getMonth(), d.getDate() + days, 23, 59, 59);
    return end.getTime() <= d.getTime() ? end.getTime() + 7 * 864e5 : end.getTime();
  }

  function formatCountdown(ms) {
    var s = Math.max(0, Math.floor(ms / 1000));
    var d = Math.floor(s / 86400); s -= d * 86400;
    var h = Math.floor(s / 3600); s -= h * 3600;
    var mi = Math.floor(s / 60); s -= mi * 60;
    var p = function (n) { return (n < 10 ? '0' : '') + n; };
    return (d > 0 ? d + 'd ' : '') + p(h) + 'u ' + p(mi) + 'm ' + p(s) + 's';
  }

  function initCountdown() {
    var els = document.querySelectorAll('[data-ap-countdown]');
    if (!els.length) return;
    var end = promoEnd();
    function tick() {
      var text = formatCountdown(end - Date.now());
      els.forEach(function (el) { el.textContent = text; });
    }
    tick();
    setInterval(tick, 1000);
  }

  function initCartOpenButtons() {
    document.querySelectorAll('[data-ap-open-cart]').forEach(function (btn) {
      btn.addEventListener('click', function () { openCartDrawer(); });
    });
  }

  function openCartDrawer() {
    var drawer = document.getElementById('Cart-Drawer');
    if (drawer && typeof drawer.open === 'function') {
      drawer.open();
    } else if (drawer) {
      drawer.classList.add('is-visible');
    }
  }

  // Scrolls the rating badge to whichever Loox reviews widget is present on
  // the page (the card carousel on the standard product page, or the
  // dynamic reviews section used on the campaign landing page) — a no-op if
  // neither is present, rather than an error.
  function initReviewScroll() {
    document.querySelectorAll('[data-ap-scroll-reviews]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        // The trigger button itself contains a .loox-widget rating badge —
        // explicitly skip anything inside the button so we don't just
        // "scroll" to itself instead of the real reviews section further
        // down the page.
        var candidates = document.querySelectorAll('.loox-v2-carousel-container, .loox-widget, [data-loox], [id*="loox"]');
        var target = null;
        for (var i = 0; i < candidates.length; i++) {
          if (!btn.contains(candidates[i])) { target = candidates[i]; break; }
        }
        if (target) target.scrollIntoView({ behavior: 'smooth', block: 'center' });
      });
    });
  }

  /* ---------- configurator ---------- */

  function initConfigurator(root) {
    var dataEl = root.querySelector('[data-ap-copy]');
    if (!dataEl) return;
    var copy;
    try {
      copy = JSON.parse(dataEl.textContent);
    } catch (e) {
      return;
    }

    var bundlesEl = root.querySelector('[data-ap-bundles]');
    var bundles;
    try {
      bundles = JSON.parse(bundlesEl.textContent);
    } catch (e) {
      bundles = [];
    }

    var marketImages = MARKET_GALLERY[copy.marketLocale] || MARKET_GALLERY.en;

    var state = {
      bundle: bundles.length ? (bundles.filter(function (b) { return b.qty === 2; })[0] || bundles[0]).qty : 1,
      browse: 'day',
      picks: [],
      gi: 0,
      error: ''
    };

    var els = {
      bundleList: root.querySelector('[data-ap-bundle-list]'),
      lensList: root.querySelector('[data-ap-lens-list]'),
      colorRow: root.querySelector('[data-ap-color-row]'),
      modelGrid: root.querySelector('[data-ap-model-grid]'),
      chosenList: root.querySelector('[data-ap-chosen-list]'),
      errorBanner: root.querySelector('[data-ap-error]'),
      pickTitle: root.querySelector('[data-ap-pick-title]'),
      pickCounter: root.querySelector('[data-ap-pick-counter]'),
      addBtn: document.querySelectorAll('[data-ap-add-to-cart]'),
      galleryMain: root.querySelector('[data-ap-gallery-main]'),
      galleryEmpty: root.querySelector('[data-ap-gallery-empty]'),
      galleryBadgeSave: root.querySelector('[data-ap-badge-save]'),
      galleryBadgeBlock: root.querySelector('[data-ap-badge-block]'),
      galleryThumbs: root.querySelector('[data-ap-gallery-thumbs]'),
      galleryStack: root.querySelector('[data-ap-gallery-stack]'),
      galleryNav: root.querySelector('[data-ap-gallery-nav]'),
      eyebrowModel: root.querySelector('[data-ap-eyebrow-model]'),
      heroTitle: root.querySelector('[data-ap-hero-title]'),
      lensBadge: root.querySelector('[data-ap-lens-badge]'),
      uspFilter: root.querySelector('[data-ap-usp-filter]'),
      uspMoment: root.querySelector('[data-ap-usp-moment]'),
      activePrice: document.querySelectorAll('[data-ap-active-price]'),
      activeCompare: document.querySelectorAll('[data-ap-active-compare]'),
      activeCompareWrap: document.querySelectorAll('[data-ap-active-compare-wrap]'),
      perUnitLabel: root.querySelector('[data-ap-per-unit-label]'),
      urgencyBadge: root.querySelector('[data-ap-urgency-badge]'),
      addLabel: document.querySelectorAll('[data-ap-add-label]'),
      modelTitle: document.querySelectorAll('[data-ap-model-title]'),
      selectionLabel: document.querySelector('[data-ap-selection-label]'),
      stickyBar: root.querySelector('[data-ap-sticky-bar]'),
      stickyImg: root.querySelector('[data-ap-sticky-img]')
    };

    function modelByName(name) {
      return MODELS.filter(function (m) { return m.name === name; }).find(function () { return true; });
    }
    function imagesOf(mo, lens) { return lens === 'day' ? mo.day : mo.night; }

    // Colors this model+lens actually offers, filtered down to what's currently
    // purchasable. Availability is baked into each color entry (variantId/available)
    // at build time via the Admin API, so this is a synchronous, market-independent
    // check — no live per-domain product lookup involved.
    function availableColorsFor(mo, lens) {
      var imgs = imagesOf(mo, lens);
      if (!imgs) return [];
      return Object.keys(imgs).filter(function (c) { return imgs[c].available; });
    }
    function availableModels(lens) {
      return MODELS.filter(function (x) {
        if (lens === 'day' ? !x.day : !x.night) return false;
        return availableColorsFor(x, lens).length > 0;
      });
    }
    function lastPick() { return state.picks.length ? state.picks[state.picks.length - 1] : null; }
    function lensNameOf(lens) { return lens === 'night' ? copy.lensNightName : copy.lensDayName; }

    function activeBundle() {
      return bundles.filter(function (b) { return b.qty === state.bundle; }).find(function () { return true; }) || bundles[0];
    }

    function projectedTotalFor(qty) {
      // Discount % is currency-agnostic, computed straight from the fixed
      // EUR amounts. Displayed strings come from copy.tierPrices (Shopify's
      // `money` filter output for the shopper's active market/currency),
      // falling back to EUR-formatted text if that data isn't present.
      var was = Math.round(UNIFORM_BUNDLE_PRICE * qty * 100) / 100;
      var discountAmount = TIER_DISCOUNT_AMOUNT[qty] || 0;
      var price = Math.round((was - discountAmount) * 100) / 100;
      var discountRate = was > 0 ? discountAmount / was : 0;

      var tierText = copy.tierPrices && copy.tierPrices[qty];
      return {
        was: was,
        price: price,
        discountRate: discountRate,
        wasText: tierText ? tierText.was : eur(was),
        priceText: tierText ? tierText.price : eur(price),
        saveText: tierText ? tierText.save : eur(was - price),
        perUnitText: tierText ? tierText.perUnit : eur(Math.round((price / qty) * 100) / 100)
      };
    }

    function gallery() {
      var p = lastPick();
      if (!p) return [];
      var mo = modelByName(p.model);
      if (!mo) return [];
      var imgs = imagesOf(mo, p.lens);
      if (!imgs || !imgs[p.frame]) return [];
      var extra = p.lens === 'day' ? mo.dayExtra : mo.nightExtra;
      return [imgs[p.frame].src]
        .concat(extra.filter(function (x) { return x.c === p.frame; }).map(function (x) { return x.src; }))
        .concat(marketImages);
    }

    function pluralize(count, template) {
      return template.replace('{count}', count);
    }

    function setError(msg) {
      state.error = msg || '';
      if (els.errorBanner) {
        if (msg) {
          els.errorBanner.hidden = false;
          els.errorBanner.querySelector('[data-ap-error-text]').textContent = msg;
        } else {
          els.errorBanner.hidden = true;
        }
      }
    }

    function toggleModel(name) {
      var lens = state.browse;
      var i = state.picks.findIndex(function (p) { return p.model === name && p.lens === lens; });
      if (i >= 0) {
        state.picks.splice(i, 1);
        state.gi = 0;
        setError('');
        render();
        return;
      }
      if (state.picks.length >= state.bundle) {
        var tmpl = state.bundle === 1 ? copy.errorFullSingular : copy.errorFullPlural;
        setError(tmpl.replace('{count}', state.bundle));
        return;
      }
      var mo = modelByName(name);
      var colors = availableColorsFor(mo, lens);
      if (!colors.length) return;
      state.picks.push({ lens: lens, model: name, frame: colors[0] });
      state.gi = 0;
      setError('');
      render();
    }

    function setPickColor(i, c) {
      if (!state.picks[i]) return;
      state.picks[i].frame = c;
      state.gi = 0;
      setError('');
      render();
    }

    function removePick(i) {
      state.picks.splice(i, 1);
      setError('');
      render();
    }

    function selectBundle(qty) {
      state.bundle = qty;
      state.picks = state.picks.slice(0, qty);
      state.gi = 0;
      setError('');
      render();
    }

    function selectLens(lens) {
      state.browse = lens;
      setError('');
      render();
      document.querySelectorAll('[data-ap-lens-sync]').forEach(function (el) {
        el.classList.toggle('is-active', el.getAttribute('data-ap-lens-sync') === lens);
      });
    }
    root.addEventListener('ap-lp:select-lens', function (e) { selectLens(e.detail.lens); });

    function renderBundleList() {
      if (!els.bundleList) return;
      var a = activeBundle();
      els.bundleList.querySelectorAll('[data-ap-bundle-opt]').forEach(function (btn) {
        var qty = Number(btn.getAttribute('data-ap-bundle-opt'));
        btn.classList.toggle('is-active', qty === state.bundle);

        var projected = projectedTotalFor(qty);
        var nowEl = btn.querySelector('.ap-lp-bundle-opt__price-now');
        var wasEl = btn.querySelector('.ap-lp-bundle-opt__price-was');
        if (nowEl) nowEl.textContent = projected.priceText;
        if (wasEl) wasEl.hidden = projected.was <= projected.price;
        if (wasEl && !wasEl.hidden) wasEl.textContent = projected.wasText;

        var perEl = btn.querySelector('[data-ap-bundle-per-unit]');
        if (perEl) {
          perEl.hidden = qty <= 1;
          if (qty > 1) perEl.textContent = projected.perUnitText + ' ' + copy.perBrilLabel;
        }
      });
      return a;
    }

    function renderLensTabs() {
      if (els.lensList) {
        els.lensList.querySelectorAll('[data-ap-lens-opt]').forEach(function (btn) {
          btn.classList.toggle('is-active', btn.getAttribute('data-ap-lens-opt') === state.browse);
        });
      }
      var isDay = state.browse === 'day';
      if (els.uspFilter) els.uspFilter.textContent = isDay ? copy.lensDayUspFilter : copy.lensNightUspFilter;
      if (els.uspMoment) els.uspMoment.textContent = isDay ? copy.lensDayUspMoment : copy.lensNightUspMoment;
    }

    function renderColorRow() {
      if (!els.colorRow) return;
      var last = lastPick();
      if (!last) { els.colorRow.hidden = true; return; }
      var mo = modelByName(last.model);
      var colors = availableColorsFor(mo, last.lens);
      if (colors.length <= 1) { els.colorRow.hidden = true; return; }
      els.colorRow.hidden = false;
      var swatchWrap = els.colorRow.querySelector('[data-ap-color-swatches]');
      var label = els.colorRow.querySelector('[data-ap-color-label]');
      if (label) label.textContent = last.frame;
      if (swatchWrap) {
        swatchWrap.innerHTML = colors.map(function (c) {
          var active = c === last.frame;
          var bg = SWATCH[c] || '#DFDCD4';
          return '<button type="button" class="ap-lp-swatch' + (active ? ' is-active' : '') + '" data-ap-color-pick="' + c.replace(/"/g, '&quot;') + '" style="background:' + bg + '" aria-label="' + c.replace(/"/g, '&quot;') + '"></button>';
        }).join('');
        swatchWrap.querySelectorAll('[data-ap-color-pick]').forEach(function (btn) {
          btn.addEventListener('click', function () {
            setPickColor(state.picks.length - 1, btn.getAttribute('data-ap-color-pick'));
          });
        });
      }
    }

    function renderModelGrid() {
      if (!els.modelGrid) return;
      var list = availableModels(state.browse);
      els.modelGrid.innerHTML = list.map(function (mo) {
        var imgs = imagesOf(mo, state.browse);
        var on = state.picks.some(function (p) { return p.model === mo.name && p.lens === state.browse; });
        var thumbColors = availableColorsFor(mo, state.browse);
        var src = imgs[thumbColors[0]].src;
        return '' +
          '<button type="button" class="ap-lp-model' + (on ? ' is-active' : '') + '" data-ap-model-pick="' + mo.name.replace(/"/g, '&quot;') + '">' +
          (on ? '<span class="ap-lp-model__check" aria-label="' + copy.removeLabel + '">×</span>' : '') +
          '<span class="ap-lp-model__thumb"><img src="' + src + '" alt="AmaraPure ' + mo.name + '" loading="lazy"></span>' +
          '<span class="ap-lp-model__name">' + mo.name + '</span>' +
          '</button>';
      }).join('');
      els.modelGrid.querySelectorAll('[data-ap-model-pick]').forEach(function (btn) {
        btn.addEventListener('click', function () { toggleModel(btn.getAttribute('data-ap-model-pick')); });
      });
    }

    function renderChosenList() {
      if (!els.chosenList) return;
      if (!state.picks.length) { els.chosenList.hidden = true; return; }
      els.chosenList.hidden = false;
      els.chosenList.innerHTML = state.picks.map(function (p, i) {
        var mo = modelByName(p.model);
        var imgs = imagesOf(mo, p.lens);
        var src = imgs[p.frame].src;
        return '' +
          '<div class="ap-lp-chosen-item">' +
          '<span class="ap-lp-chosen-item__thumb"><img src="' + src + '" alt="' + lensNameOf(p.lens) + ' ' + mo.name + '" loading="lazy"></span>' +
          '<span class="ap-lp-chosen-item__meta"><span class="ap-lp-chosen-item__title">' + lensNameOf(p.lens) + ' ' + mo.name + '</span><span class="ap-lp-chosen-item__color">' + p.frame + '</span></span>' +
          '<button type="button" class="ap-lp-chosen-item__remove" data-ap-remove-pick="' + i + '" aria-label="' + copy.removeLabel + '">×</button>' +
          '</div>';
      }).join('');
      els.chosenList.querySelectorAll('[data-ap-remove-pick]').forEach(function (btn) {
        btn.addEventListener('click', function () { removePick(Number(btn.getAttribute('data-ap-remove-pick'))); });
      });
    }

    function renderGallery() {
      var g = gallery();
      var gi = g.length ? Math.min(state.gi, g.length - 1) : 0;
      var last = lastPick();

      if (els.galleryMain) {
        if (g.length) {
          els.galleryMain.src = g[gi];
          els.galleryMain.hidden = false;
        } else {
          els.galleryMain.hidden = true;
        }
      }
      if (els.galleryEmpty) els.galleryEmpty.hidden = !!g.length;
      if (els.galleryBadgeBlock) {
        els.galleryBadgeBlock.hidden = !g.length;
        if (g.length) {
          var isDay = state.browse !== 'night';
          els.galleryBadgeBlock.textContent = (isDay ? '84%' : '97%') + ' ' + copy.filteredBadgeLabel;
          els.galleryBadgeBlock.style.background = isDay ? '#E9D48F' : '#E9B478';
        }
      }

      if (els.galleryThumbs) {
        var showThumbs = window.innerWidth <= 860 && g.length > 1;
        els.galleryThumbs.hidden = !showThumbs;
        if (showThumbs) {
          els.galleryThumbs.innerHTML = g.slice(0, 3).map(function (src, i) {
            return '<button type="button" class="ap-lp-thumb' + (i === gi ? ' is-active' : '') + '" data-ap-thumb="' + i + '"><img src="' + src + '" alt="" loading="lazy"></button>';
          }).join('');
          els.galleryThumbs.querySelectorAll('[data-ap-thumb]').forEach(function (btn) {
            btn.addEventListener('click', function () { state.gi = Number(btn.getAttribute('data-ap-thumb')); render(); });
          });
        }
      }
      if (els.galleryStack) {
        var showStack = window.innerWidth > 860 && g.length > 1;
        els.galleryStack.hidden = !showStack;
        if (showStack) {
          els.galleryStack.innerHTML = g.slice(1, 4).map(function (src) {
            return '<div class="ap-lp-stack-item"><img src="' + src + '" alt="AmaraPure ' + (last ? last.model : '') + '" loading="lazy"></div>';
          }).join('');
        }
      }
      if (els.galleryNav) els.galleryNav.hidden = !(g.length > 1);

      if (els.eyebrowModel) els.eyebrowModel.textContent = last ? lensNameOf(last.lens) + ' ' + last.model : copy.eyebrowDefault;
      if (els.heroTitle) els.heroTitle.textContent = last ? lensNameOf(last.lens) + ' ' + last.model : copy.eyebrowDefault;
      if (els.lensBadge) {
        var isNight = last && last.lens === 'night';
        els.lensBadge.textContent = last ? (isNight ? copy.lensNightBadge : copy.lensDayBadge) : '';
        els.lensBadge.hidden = !last;
        els.lensBadge.classList.toggle('is-night', !!isNight);
      }
      els.modelTitle.forEach(function (el) {
        el.textContent = last ? lensNameOf(last.lens) + ' ' + last.model + ', ' + last.frame : copy.noSelectionLabel;
      });
      if (els.stickyImg && g.length) els.stickyImg.src = g[gi];

      var cmpImg = document.querySelector('[data-ap-compare-img]');
      if (cmpImg && g.length) cmpImg.src = g[gi];
      var ctaImg = document.querySelector('[data-ap-cta-img]');
      if (ctaImg && g.length) ctaImg.src = g[gi];
    }

    function renderPickState() {
      var left = state.bundle - state.picks.length;
      if (els.pickTitle) {
        if (left > 0) {
          els.pickTitle.textContent = state.bundle === 1 ? copy.pickTitleSingle : copy.pickTitleMulti.replace('{count}', state.bundle);
        } else {
          els.pickTitle.textContent = copy.pickTitleDone;
        }
      }
      if (els.pickCounter) els.pickCounter.textContent = copy.pickCounterTemplate.replace('{picked}', state.picks.length).replace('{total}', state.bundle);
    }

    function renderPricing() {
      var a = activeBundle();
      if (!a) return;

      // Project the real total from the actual selected models instead of a
      // flat marketing number — becomes exact once every slot is filled, and
      // updates live as picks change. Duo/Trio get the real 50% bundle
      // discount; Solo uses the plain real price of whichever model is picked.
      // Displayed amounts come from Shopify's own `money` filter (see
      // tierPrices in data-ap-copy), so they're correctly converted and
      // formatted for whichever market/currency the shopper is in — the
      // discount percentage is currency-agnostic so it's computed directly.
      var projected = projectedTotalFor(state.bundle);
      var discount = projected.was > projected.price;
      var pct = Math.round(projected.discountRate * 100);

      els.activePrice.forEach(function (el) { el.textContent = projected.priceText; });
      els.activeCompare.forEach(function (el) { el.textContent = projected.wasText; });
      els.activeCompareWrap.forEach(function (el) { el.hidden = !discount; });

      if (els.perUnitLabel) {
        els.perUnitLabel.textContent = a.qty > 1
          ? projected.perUnitText + ' ' + copy.perBrilLabel + ', ' + copy.saveWord + ' ' + projected.saveText
          : copy.saveWord.charAt(0).toUpperCase() + copy.saveWord.slice(1) + ' ' + projected.saveText;
      }
      if (els.urgencyBadge) els.urgencyBadge.textContent = pct + '% ' + copy.discountWord;
      if (els.galleryBadgeSave) {
        els.galleryBadgeSave.hidden = !discount;
        els.galleryBadgeSave.textContent = pct + '% ' + copy.discountWord;
      }
      els.addLabel.forEach(function (el) { el.textContent = copy.addToCartLabel + ', ' + projected.priceText; });
      if (els.selectionLabel) {
        els.selectionLabel.textContent = discount ? a.name + ', ' + pct + '% ' + copy.discountWord : a.name;
      }
    }

    function renderCtaText() {
      var el = document.querySelector('[data-ap-cta-text]');
      if (!el) return;
      var tmpl = el.getAttribute('data-ap-cta-text-template') || '';
      var last = lastPick();
      var model = last ? lensNameOf(last.lens) + ' ' + last.model : copy.noSelectionLabel;
      var pct = state.browse === 'night' ? '97%' : '84%';
      el.textContent = tmpl.replace('{model}', model).replace('{pct}', pct);
    }

    function render() {
      var a = renderBundleList();
      renderLensTabs();
      renderColorRow();
      renderModelGrid();
      renderChosenList();
      renderGallery();
      renderPickState();
      renderPricing();
      renderCtaText();
    }

    /* bundle buttons */
    if (els.bundleList) {
      els.bundleList.querySelectorAll('[data-ap-bundle-opt]').forEach(function (btn) {
        btn.addEventListener('click', function () { selectBundle(Number(btn.getAttribute('data-ap-bundle-opt'))); });
      });
    }
    /* lens tab buttons inside the hero */
    if (els.lensList) {
      els.lensList.querySelectorAll('[data-ap-lens-opt]').forEach(function (btn) {
        btn.addEventListener('click', function () { selectLens(btn.getAttribute('data-ap-lens-opt')); });
      });
    }
    /* lens cards inside the separate "Daygold vs Midnight" section */
    document.querySelectorAll('[data-ap-lens-select]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        document.dispatchEvent(new CustomEvent('ap-lp:select-lens', { detail: { lens: btn.getAttribute('data-ap-lens-select') } }));
      });
    });
    document.addEventListener('ap-lp:select-lens', function (e) { selectLens(e.detail.lens); });

    /* gallery prev/next */
    if (els.galleryNav) {
      var prevBtn = els.galleryNav.querySelector('[data-ap-gallery-prev]');
      var nextBtn = els.galleryNav.querySelector('[data-ap-gallery-next]');
      if (prevBtn) prevBtn.addEventListener('click', function () {
        var g = gallery();
        if (!g.length) return;
        state.gi = (state.gi + g.length - 1) % g.length;
        render();
      });
      if (nextBtn) nextBtn.addEventListener('click', function () {
        var g = gallery();
        if (!g.length) return;
        state.gi = (state.gi + 1) % g.length;
        render();
      });
    }

    function setAddButtonsBusy(busy) {
      els.addBtn.forEach(function (btn) {
        btn.disabled = busy;
        btn.classList.toggle('is-loading', busy);
      });
    }

    function addToCart() {
      var missing = state.bundle - state.picks.length;
      if (missing > 0) {
        var tmpl = missing === 1 ? copy.errorMissingSingular : copy.errorMissingPlural;
        setError(tmpl.replace('{count}', missing));
        return;
      }

      setAddButtonsBusy(true);

      // Variant ids + availability are baked into MODELS at build time (Admin API),
      // so resolution here is synchronous and works identically on every market
      // domain — no live per-domain product/handle lookup involved.
      var resolved = state.picks.map(function (p) {
        var mo = modelByName(p.model);
        var imgs = imagesOf(mo, p.lens);
        var entry = imgs ? imgs[p.frame] : null;
        return { pick: p, entry: entry };
      });

      var unavailable = resolved.filter(function (r) { return !r.entry || !r.entry.available; });
      if (unavailable.length) {
        var first = unavailable[0].pick;
        var mo = modelByName(first.model);
        var label = lensNameOf(first.lens) + ' ' + mo.name + ', ' + first.frame;
        setError(copy.errorOutOfStock.replace('{model}', label));
        setAddButtonsBusy(false);
        return;
      }

      // All picker purchases (Solo/Duo/Trio) use a separate set of variant ids
      // (same SKU/barcode, kept out of the collections the sitewide "1+1
      // gratis" discount targets, uniformly priced at €79) instead of the
      // regular storefront variant ids. This keeps that discount from
      // stacking, and lets the fixed-amount "Bundelkorting Solo/Duo/Trio"
      // discounts land on an exact €59/€79/€109 total every time.
      var items = resolved.map(function (r) {
        return { id: r.entry.bundleVariantId, quantity: 1 };
      });
      var payload = { items: items };
      // Set on product pages running the offer A/B test (see
      // product-information-v1.liquid); absent on the standalone landing
      // page, which isn't part of that test.
      if (window.apAbOfferVariant) {
        payload.attributes = { _ab_variant: window.apAbOfferVariant };
      }
      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(payload)
      })
        .then(function (res) { return res.json().then(function (data) { return { ok: res.ok, data: data }; }); })
        .then(function (result) {
          if (!result.ok) {
            setError(result.data && result.data.description ? result.data.description : copy.errorMissingSingular.replace('{count}', 1));
            return;
          }
          if (window.apAbOfferVariant && typeof gtag === 'function') {
            gtag('event', 'ab_offer_add_to_cart', {
              ab_variant: window.apAbOfferVariant,
              value: projectedTotalFor(state.bundle).price,
              currency: 'EUR'
            });
          }
          document.dispatchEvent(new CustomEvent('cart:refresh', { detail: { cart: result.data } }));
          openCartDrawer();
        })
        .catch(function () {})
        .finally(function () {
          setAddButtonsBusy(false);
        });
    }

    document.querySelectorAll('[data-ap-add-to-cart]').forEach(function (btn) {
      btn.addEventListener('click', addToCart);
    });

    window.addEventListener('resize', function () { renderGallery(); });

    // On a product page (see offer-test-bundle.liquid), default to THAT
    // product's own model/lens instead of the sitewide bestseller, so the
    // picker opens on what the visitor actually came here for.
    var pageModel = root.dataset.defaultModel ? modelByName(root.dataset.defaultModel) : null;
    var pageLens = root.dataset.defaultLens === 'night' ? 'night' : 'day';
    var pageColors = pageModel ? availableColorsFor(pageModel, pageLens) : [];

    if (pageColors.length) {
      state.browse = pageLens;
      state.picks = [{ lens: pageLens, model: pageModel.name, frame: pageColors[0] }];
    } else {
      // Nona Midnight is the best seller — default to it when in stock. Otherwise
      // fall back to the first available day model, then the first available
      // night model, so the picker never opens on (or offers) something unavailable.
      var bestSeller = modelByName('Nona');
      var bestSellerColors = bestSeller ? availableColorsFor(bestSeller, 'night') : [];
      if (bestSellerColors.length) {
        state.browse = 'night';
        state.picks = [{ lens: 'night', model: 'Nona', frame: bestSellerColors[0] }];
      } else {
        var dayModels = availableModels('day');
        if (dayModels.length) {
          var defaultMo = dayModels[0];
          var defaultColors = availableColorsFor(defaultMo, 'day');
          state.picks = [{ lens: 'day', model: defaultMo.name, frame: defaultColors[0] }];
        } else {
          var nightModels = availableModels('night');
          if (nightModels.length) {
            var defaultMoN = nightModels[0];
            var defaultColorsN = availableColorsFor(defaultMoN, 'night');
            state.browse = 'night';
            state.picks = [{ lens: 'night', model: defaultMoN.name, frame: defaultColorsN[0] }];
          }
        }
      }
    }
    render();
  }

  /* ---------- info accordion (hero product-info panels + main FAQ) ---------- */

  function initAccordions() {
    document.querySelectorAll('[data-ap-accordion]').forEach(function (acc) {
      acc.querySelectorAll('[data-ap-accordion-item]').forEach(function (item) {
        var btn = item.querySelector('[data-ap-accordion-toggle]');
        var body = item.querySelector('[data-ap-accordion-body]');
        var icon = item.querySelector('[data-ap-accordion-icon]');
        if (!btn || !body) return;
        btn.addEventListener('click', function () {
          var open = !body.hidden;
          body.hidden = open;
          if (icon) icon.textContent = open ? '+' : '−';
        });
      });
    });
  }

  /* ---------- testimonial videos ---------- */

  function initVideos() {
    var allVideos = [];
    document.querySelectorAll('[data-ap-video-tile]').forEach(function (tile) {
      var video = tile.querySelector('video');
      var overlay = tile.querySelector('[data-ap-video-overlay]');
      if (!video || !overlay) return;
      allVideos.push(video);
      overlay.addEventListener('click', function () {
        allVideos.forEach(function (v) { if (v !== video && !v.paused) v.pause(); });
        var p = video.play();
        if (p && p.catch) p.catch(function () {});
      });
      video.addEventListener('playing', function () {
        overlay.hidden = true;
        video.controls = true;
        allVideos.forEach(function (v) { if (v !== video && !v.paused) v.pause(); });
      });
      video.addEventListener('pause', function () {
        overlay.hidden = false;
        video.controls = false;
      });
    });
  }

  /* ---------- mobile sticky add-to-cart bar ---------- */

  function initStickyBar() {
    var bar = document.querySelector('[data-ap-sticky-bar]');
    if (!bar) return;
    function sync() {
      var isMobile = window.innerWidth <= 860;
      var scrolled = window.scrollY > 640;
      bar.hidden = !(isMobile && scrolled);
    }
    window.addEventListener('scroll', sync, { passive: true });
    window.addEventListener('resize', sync);
    sync();
  }

  function safeRun(name, fn) {
    try {
      fn();
    } catch (e) {
      console.error('[lp-blauwlicht] ' + name + ' failed:', e);
    }
  }

  function init() {
    safeRun('initCountdown', initCountdown);
    safeRun('initCartOpenButtons', initCartOpenButtons);
    safeRun('initReviewScroll', initReviewScroll);
    safeRun('initAccordions', initAccordions);
    safeRun('initVideos', initVideos);
    safeRun('initStickyBar', initStickyBar);
    safeRun('initConfigurator', function () {
      var hero = document.querySelector('[data-ap-configurator]');
      if (hero) initConfigurator(hero);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
